/* eslint-disable functional/immutable-data */
import { AxiosError } from 'axios';

export function isAxiosError<T>(e: unknown): e is AxiosError<T> {
  return (e as AxiosError)?.isAxiosError;
}

export function sanitizeAxiosError<T>(e?: AxiosError<T>) {
  delete e?.config?.data;
}

export function isNotFoundError(error?: AxiosError) {
  return error?.response?.status === 404;
}

export function isSlugNotFound(error?: AxiosError, id?:string) {
  return error?.response?.data?.message === `Merchant not found for slug: ${id}`;
}
